import React from "react";
import { Box, Modal } from "@mui/material";

const CommonModal = ({ children, width, open, setOpen }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width || 400,
    bgcolor: "background.paper",
    backdropFilter: "blur(10px)",
    borderRadius: 1.5,
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={style}>{children}</Box>
    </Modal>
  );
};
export default CommonModal;
